import { makeAutoObservable, runInAction } from "mobx";
import { ContactService, type LeadData } from "../services/ContactService";

export class ContactStore {
  whatsappNumber = "5531996915436";
  brokerName = "José Américo Mendicino";
  isSending = false;
  lastError: string | null = null;
  lastSuccess = false;

  private service = new ContactService();

  constructor() {
    makeAutoObservable(this);
  }

  openWhatsApp(message?: string): void {
    const link = `https://wa.me/${this.whatsappNumber}${message ? `?text=${encodeURIComponent(message)}` : ""}`;
    window.open(link, "_blank");
  }

  openInstagram(): void {
    window.open("https://www.instagram.com/joseamericomendicino/", "_blank");
  }

  openFacebook(): void {
    window.open("https://www.facebook.com/joseamerico.mendicino.3", "_blank");
  }

  async sendLead(data: LeadData): Promise<boolean> {
    this.isSending = true;
    this.lastError = null;
    this.lastSuccess = false;
    try {
      await this.service.sendLead(data);
      runInAction(() => {
        this.isSending = false;
        this.lastSuccess = true;
      });
      return true;
    } catch (err) {
      runInAction(() => {
        this.isSending = false;
        this.lastError =
          err instanceof Error ? err.message : "Erro ao enviar mensagem";
      });
      return false;
    }
  }

  reset(): void {
    this.lastError = null;
    this.lastSuccess = false;
  }
}
